import { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { corporateMembersFormData } from "./data/CorporateMembersForm.data";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { CorporateMembersListConfig } from "./data/CorporateMembersListConfig";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownFieldForCorporateDashboard } from "./utils/dropdownUtils";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { useGetAllCorporateMemberListMutation } from "../../app/services/corporateMembership/corporateMemberApi";
import { useNavigate } from "react-router-dom";
import { encryptAESID } from "../../utils/Encryption";

const CorporateMembersList = () => {
  const CorporateMembersRef = useRef();
  const molGridRef = useRef();
  const navigate = useNavigate();
  const [CorporateMembersForm, setCorporateMembersForm] = useState(corporateMembersFormData);
  const [totalRecord, setTotalRecord] = useState()
  const [dataSource, setDataSource] = useState([])
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    FilterByMembershipType: null,
    FilterByStatus: null,
    SearchByCompanyNameUEN: null,
    organisationCategoryId:null
  });
  const [signUpDropDownsForCorporateMembers, { data: signUpDropDownsData, isLoading: signUpDropDownsLoading, isFetching: signUpDropDownsFetching, isError: signUpDropDownsIsError, error: signUpDropDownsError, }] = useLazyGetSignUpDropDownsForCorporateMembersQuery()
  const [getAllCorporateMemberList, { data: corporateMemberListData, isLoading: corporateMemberListLoading, isFetching: corporateMemberListFetching, isError: corporateMemberListIsError, error: corporateMemberListError, }] = useGetAllCorporateMemberListMutation();

  const handleSearch = () => {
    debugger
    if (!CorporateMembersRef.current) {
      return
    }
    const formData = CorporateMembersRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      SearchByCompanyNameUEN: formData?.SearchByCompanyNameUEN,
      FilterByMembershipType: formData?.FilterByMembershipType?.value ? formData?.FilterByMembershipType?.value : null,
      FilterByStatus: formData?.FilterByStatus?.value ?? null,
      OrganisationCategoryId: formData?.organisationCategoryId?.value  ?? null
    };
    setPaginationRequest(updatedPaginationRequest)
    getAllCorporateMemberList(updatedPaginationRequest);
  }

  const handleClearClick = () => {
    const updatedFormData = { ...CorporateMembersForm };
    updatedFormData.initialState = {
      SearchByCompanyNameUEN: null,
      FilterByMembershipType: null,
      FilterByStatus: null,
      organisationCategoryId:null
    };

    const request = {
      ...paginationRequest,
      SearchByCompanyNameUEN: null,
      FilterByMembershipType: null,
      FilterByStatus: null,
      organisationCategoryId:null,
      totalCount: 0,
    };
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllCorporateMemberList(request);
    setCorporateMembersForm(updatedFormData);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllCorporateMemberList(updatedPaginationRequest);
  };

  const handleViewClick = (data) => {
    navigate(`/viewCorporateMember/${encryptAESID(data?.sgbcCorporateMemberId)}`);
  }

  const actionHandler = {
    VIEW: handleViewClick,
  };

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    getAllCorporateMemberList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownFieldForCorporateDashboard(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

  useEffect(() => {
    if (!corporateMemberListLoading && corporateMemberListData) {
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: corporateMemberListData?.totalCount,
      }));
      setTotalRecord(corporateMemberListData?.totalCount)
      setDataSource(corporateMemberListData?.itemList)
    }
  }, [corporateMemberListLoading, corporateMemberListData]);


  return (

    !signUpDropDownsData ? (<DataLoader />
    ) : (

      <div className="corporate-member-list">
        <div className="member-list-filter row">
          <div className="row col-8">
            <FormCreator
              ref={CorporateMembersRef}
              {...CorporateMembersForm}
            />
          </div>
          <div className="col-4 right-side-btn">
            <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn black-btn  mr-0 mt-2"
              onClick={handleClearClick}
            />
            <Buttons
              buttonText="Search"
              buttonTypeClassName="btn success-btn  mr-0 mt-2"
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="member-list corporate-member-list-table">
          <div>
            <h4>{totalRecord} Corporate Members</h4>
          </div>
          <MolGrid
            ref={molGridRef}
            configuration={CorporateMembersListConfig}
            dataSource={dataSource}
            allowPagination={true}
            onPageChange={handlePageChange}
            pagination={paginationRequest}
            isLoading={corporateMemberListFetching}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    ));
};

export default CorporateMembersList;
